import { render, staticRenderFns } from "./JeecgOrderDMainList.vue?vue&type=template&id=56f4053a&scoped=true"
import script from "./JeecgOrderDMainList.vue?vue&type=script&lang=js"
export * from "./JeecgOrderDMainList.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderDMainList.vue?vue&type=style&index=0&id=56f4053a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4053a",
  null
  
)

export default component.exports